import React, { useState } from 'react';
import styled from 'styled-components';
import { Switch as LegacySwitch } from '@material-ui/core';

const StyledSwitch = styled(LegacySwitch)`
  &.MuiSwitch-root {
    z-index: 1;
    .MuiSwitch-track {
      background-color: ${({ theme }) => theme.colors.gray500};
    }
    .MuiButtonBase-root {
      color: ${({ theme }) => theme.colors.gray600};
      &.Mui-checked {
        color: ${({ theme }) => theme.colors.gbrand500};
      }
    }
  }
`;

const Switch = ({ active = false, onChange, dataTestid }) => {
  const [switchState, setSwitchState] = useState(active);
  const handleToggle = () => {
    onChange(!switchState);
    setSwitchState((state) => !state);
  };

  return (
    <StyledSwitch
      item
      checked={switchState}
      id="switch-qr-grid"
      onChange={handleToggle}
      size="small"
      data-testid={dataTestid}
    />
  );
};

export default Switch;
